window.templates = {

  twitchChat: `<div data-component="twitch-chat"></div>`,

  openPack: `
    <div data-component="open-pack" class="always-display">
      <div class="open-pack-wrapper" v-bind:class="{ show: model.packLoaded }">
        <div class="open-pack-container collapsed">
          <h2 v-if="model.twitchDisplayName" :title="model.twitchDisplayName">{{ model.twitchDisplayName }}</h2>
          <div id="opened-cards" class="opened-cards-wrapper">
            <div class="opened-cards">
              <playing-card v-bind:card="card" v-bind:show="'true'" v-for="card in model.userCards"></playing-card>
            </div>
          </div>
          <playing-card id="cover" class="cover pulse" :class="model.pack.name" v-bind:card="model.card" v-bind:show="'true'"></playing-card>
          </div>
        </div>
      </div>
    </div>
  `,

  showMedal: `
    <div data-component="show-medal" class="always-display">
      <div v-if="model.medal" v-bind:class="{ show: model.show }">
        <div>
          <h2 title="Achievement Unlocked">Achievement Unlocked</h2>
          <h3 :title="model.medal.name">{{ model.medal.name }}</h3>
        </div>
        <div class="video-container">
          <video :src="model.medal.src" class="video-overlay__video" loop muted autoplay playsinline></video>
        </div>
        <div>
          <!--<img :src="model.medal.twitchProfileImage">-->
          <h3 :title="model.medal.twitchDisplayName">{{ model.medal.twitchDisplayName }}</h3>
          <h4 :title="model.medal.description">{{ model.medal.description }}</h4>
        </div>
      </div>
    </div>
  `,

  showKey: `
    <div data-component="show-key" class="always-display">
      <div v-if="model.key" v-bind:class="{ show: model.show }">
        <div>
          <h2>Key Used</h2>
          <h3>{{ model.key.name }}</h3>
        </div>
        <div class="video-container">
          <video :src="model.key.src" :data-id="model.key.keyId" class="video-overlay__video" loop muted autoplay playsinline></video>
        </div>
        <div>
          <!--<img :src="model.key.twitchProfileImage">-->
          <h3>{{ model.key.twitchDisplayName }}</h3>
          <h4>{{ model.key.description }}</h4>
        </div>
      </div>
    </div>
  `,

  receivedKey: `
    <div data-component="received-key" class="always-display">
      <div v-if="model.key" v-bind:class="{ show: model.show }">
        <div>
          <h2>Key Received</h2>
          <h3>{{ model.key.name }}</h3>
        </div>
        <div class="video-container">
          <video :src="model.key.src" :data-id="model.key.keyId" class="video-overlay__video" loop muted autoplay playsinline></video>
        </div>
        <div>
          <!--<img :src="model.key.twitchProfileImage">-->
          <h3>{{ model.key.twitchDisplayName }}</h3>
          <h4>{{ model.key.description }}</h4>
        </div>
      </div>
    </div>
  `,

  receivedPack: `
    <div data-component="received-pack" class="always-display">
      <div v-if="model.pack" v-bind:class="{ show: model.show }">
        <div>
          <h2>Pack Received</h2>
          <h3>{{ model.pack.name }}</h3>
        </div>
        <div class="video-container">
          <img :src="model.pack.src" />
        </div>
        <div>
          <h3>{{ model.pack.twitchDisplayName }}</h3>
        </div>
      </div>
    </div>
  `,

  battleArena: `
    <div data-component="battle-arena" class="always-display">
      <!--<button v-on:click="stop()">stop battle</button>-->
      <div class="content">
      <!--<div class="stupid-log"></div>-->
        <div class="row info" v-bind:class="{ show: model.show.users, move: model.show.move }">
          <div class="col-5 user user1">
            <img :src="model.user1.twitchProfileImage">
            <img src="/images/name-frame-01.png">
            <div>
              <h2>{{ model.user1.twitchDisplayName }}</h2>
            </div>
          </div>
          <div class="col-2 vs">
            <h1 class="white">VS</h1>
          </div>
          <div class="col-5 user user2">
            <img :src="model.user2.twitchProfileImage">
            <img src="/images/name-frame-01.png">
            <div>
              <h2>{{ model.user2.twitchDisplayName }}</h2>
            </div>
          </div>
        </div>
        <div class="row cards" v-bind:class="{ show: model.show.cards }">
          <div class="col-4 cards-1">
            <playing-card v-bind:card="card" v-bind:show="'true'" v-for="card in model.cards1"></playing-card>
          </div>
          <div class="col-4">
            <div class="log" v-bind:class="{ show: model.show.logs }">
              <p v-for="log in model.logs" :title="log">{{ log }}</p>
            </div>
          </div>
          <div class="col-4 cards-2">
            <playing-card v-bind:card="card" v-bind:show="'true'" v-for="card in model.cards2"></playing-card>
          </div>
        </div>
      </div>
      <div class="winner" v-bind:class="{ show: model.show.winner }">
        <h2 class="white">The Winner Is:</h2>
        <div></div>
      </div>
      <div class="stolen-card" v-bind:class="{ show: model.show.stolenCard }">
        <h2 class="white">Card Stolen:</h2>
        <playing-card v-if="model.stolenCard" v-bind:card="model.stolenCard" v-bind:show="'true'"></playing-card>
      </div>
    </div>  
  `,

  playingCard: `
    <div data-component="playing-card" :id="card.id" :data-id="card.id" class="playing-card-container" :class="{ show: model.show, selected: card.selected }" :data-number="card.cardNumber" :data-cooldown="card.cooldown" :data-hidden="card.name == ''" :data-count="card.count" v-on:click="select(card)">
      <div class="playing-card-wrapper">
        <div class="playing-card" v-bind:class="{ disabled: card.name == '' }" v-on:click="flip(card.id)">
        <!--<div class="playing-card">-->
          <div class="playing-card-face playing-card-backing"></div>
          <div v-if="card.name == ''" class="playing-card-face playing-card-front disabled" :data-tier="card.tier">
            <!--<i class="question bi-question-circle"></i>-->
          </div>
          <div v-if="card.name != ''" class="playing-card-face playing-card-front" :data-tier="card.tier" :style="{'background-image': 'url(' + card.image + ')'}">
            <div class="playing-card-front-frame">
        
              <i v-if="card.cardNumber" class="check bi-check-circle-fill"></i>

              <div class="top">
                <p :title="card.name">{{ card.name }}</p>
                <p :title="card.type">{{ card.type }}</p>
              </div>

              <div v-if="model.timer" class="cooldown-timers">
                <span>  
                  <p>Cooldown</p>
                  <p>{{ card.cooldown }}</p>
                </span>
              </div>

              <div class="bottom is-hidden">
                <div class="ability" :title="'Ability: ' + card.ability" :data-description="card.description">Ability: {{ card.ability }}</div>
                <div class="stats">
                  <p :title="'ATK ' + card.attack">ATK {{ card.attack }}</p>
                  <p :title="'DEF ' + card.defence">DEF {{ card.defence }}</p>
                  <p :title="'SPD ' + card.speed">SPD {{ card.speed }}</p>
                  <p :title="'ACC ' + card.accuracy">ACC {{ card.accuracy }}</p>
                  <p :title="'HP ' + card.hp">HP {{ card.hp }}</p>
                </div>
              </div>
              <div class="info is-visible">
                <p class="number" v-if="card.cardNumber" :title="'Battle Number: #' + card.cardNumber">Battle Number: #{{ card.cardNumber }}</p>
                <p class="count" :title="'Own: ' + card.count">Own: {{card.count}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,

  navigation: `
    <div data-component="navigation" class="always-display">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'queues' }" v-on:click="click('queues')">Queues</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'leaderboard' }" v-on:click="click('leaderboard')">Leaderboard</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'cards' }" v-on:click="click('cards')">Cards</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'packs' }" v-on:click="click('packs')">Packs</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'types' }" v-on:click="click('types')">Types</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'abilities' }" v-on:click="click('abilities')">Abilities</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'keys' }" v-on:click="click('keys')">Keys</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'medals' }" v-on:click="click('medals')">Achievements</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'Admin' }" v-on:click="click('Admin')">Admin</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'settings' }" v-on:click="click('settings')">Settings</button>
        </li>
      </ul>
    </div>
  `,

  navigation2: `
    <div data-component="navigation" class="always-display light">
      <ul class="nav nav-pills justify-content-center">
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'cards' }" v-on:click="click('cards')"><i class="bi-collection-fill"></i> Cards</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'medals' }" v-on:click="click('medals')"><i class="bi bi-award-fill"></i> Achievements</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'keys' }" v-on:click="click('keys')"><i class="bi bi-key-fill"></i> Keys</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.page == 'tags' }" v-on:click="click('tags')"><i class="bi bi-tag-fill"></i> Dog Tags</button>
        </li>
      </ul>
      <ul class="nav nav-tabs justify-content-center">
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.cards == 'yours' }" v-on:click="cards('yours')">Your Cards</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.cards == 'normal' }" v-on:click="cards('normal')">Standard</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.cards == 'ultras' }" v-on:click="cards('ultras')">Ultras</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.cards == 'legendary' }" v-on:click="cards('legendary')">Legendary</button>
        </li>
        <li class="nav-item">
          <button class="nav-link" v-bind:class="{ active: model.cards == 'ultimates' }" v-on:click="cards('ultimates')">Ultimates</button>
        </li>
      </ul>
    </div>
  `,

  settings: `
    <div data-component="settings">
      <section>
        <div class="row">
          <div class="col-12">

            <div class="row" v-for="setting in model.settings">
              <div class="col-12">
                <div class="card">
                  <div class="row setting">
                    <div class="col-6 col-md-8">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom">{{ setting.description }}</label>
                    </div>
                    <div class="col-6 col-md-4">
                      <div v-if="setting.type == 'boolean'" class="form-check form-switch">
                        <input v-model="setting.value" type="checkbox" class="form-check-input" @change="save(setting.id)">
                      </div>
                      <div v-if="setting.type == 'value'">
                        <input v-model="setting.value" type="text">
                        <button class="top-margin" data-button="submit" v-on:click="save(setting.id)">Save</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="row setting">
                    <div class="col-4 col-md-8">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom">Update Twitch permissions for steam handling.</label>
                    </div>
                    <div class="col-8 col-md-4">
                      <a data-button="twitch-admin">
                        <i class="bi-twitch"></i> 
                        Connect With Twitch
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>  
  `,

  queues: `
    <div data-component="queues">
      <section>

        <div class="row">
          
          <div class="col-12">
            <div class="card">

              <div class="header">
                <h4>Current Battle</h4>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <currentBattle></currentBattle>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="card">

              <div class="header">
                <h4>Open Pack Queue</h4>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <unlockQueue></unlockQueue>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div class="col-6">
            <div class="card">

              <div class="header">
                <h4>Battle Queue</h4>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <battleQueue></battleQueue>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </section>
    </div>
  `,

  mods: `
    <div data-component="queues">
      <section>

        <div class="row">
          
          <div class="col-6">
            <div class="card">

              <div class="header">
                <h4>Current Battle</h4>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <currentBattle></currentBattle>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="col-6">
            <div class="card">

              <div class="header">
                <h4>Battle Queue</h4>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <battleQueue></battleQueue>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="row">

          <div class="col-6">
              <givePack></givePack>
          </div>

          <div class="col-6">
            <div class="card">

              <div class="header">
                <h4>Open Pack Queue</h4>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <unlockQueue></unlockQueue>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>



      </section>
    </div>
  `,

  unlockQueue: `
    <div data-component="unlock-queue" class="always-display">
      <section>
        <div class="row">
          <div class="col-12">
            <div class="row columns">
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Display Name: The users Twich display name.">User</label>
              </div>
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Pack: The pack that is being unlocked.">Pack</label>
              </div>
              <div class="col-4"></div>
            </div>
            <div v-if="!model.hasResults">
              <h4 class="no-records">No Card Unlock Requests</h4>
            </div>
            <div v-if="model.hasResults">
              <div class="row data" v-if="unlock.active" v-for="unlock in model.unlocks">
                <div class="col-4" :title="unlock.twitchDisplayName">
                  {{ unlock.twitchDisplayName }}
                </div>
                <div class="col-4" :title="model.packs[unlock.packId].name">
                  <span v-if="model.packs[unlock.packId]">{{ model.packs[unlock.packId].name }}</span>
                </div>
                <div class="col-4">
                  <button data-button="open" v-on:click="open(unlock.id)" class="small"  v-bind:class="{ 'is-disabled': unlock.disabled }">Open</button>
                  <button data-button="cancel" v-on:click="cancel(unlock.id)" class="small">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  `,

  keyQueue: `
    <div data-component="key-queue" class="always-display">
      <section>
        <div class="row">
          <div class="col-12">
            <div class="row columns">
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Display Name: The users Twich display name.">User</label>
              </div>
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Key: The keys name.">Key</label>
              </div>
              <div class="col-4"></div>
            </div>
            <div v-if="!model.hasResults">
              <h4 class="no-records">No Keys Uses</h4>
            </div>
            <div v-if="model.hasResults">
              <div class="row data" v-if="key.queue" v-for="key in model.keys">
                <div class="col-4" :title="key.twitchDisplayName">
                  {{ key.twitchDisplayName }}
                </div>
                <div class="col-4" :title="key.name">
                  {{ key.name }}
                </div>
                <div class="col-4">
                  <button data-button="use" v-on:click="use(key.id)" class="small">Use</button>
                  <button data-button="cancel" v-on:click="cancel(key.id)" class="small">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  `,

  battleQueue: `
    <div data-component="battle-queue" class="always-display">
      <section>
        <div class="row">
          <div class="col-12">
            <div class="row columns">
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 1: The Twich display name of user 1.">User 1</label>
              </div>
              <!--
              <div class="col-2">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cards 1: The cards of user 1.">Cards 1</label>
              </div>
              -->
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 2: The Twich display name of user 2.">User 2</label>
              </div>
              <!--
              <div class="col-2">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cards 2: The cards of user 2.">Cards 2</label>
              </div>
              -->
              <div class="col-4"></div>
            </div>
            <div v-if="!model.hasResults">
              <h4 class="no-records">No Card Unlock Requests</h4>
            </div>
            <div v-if="model.hasResults">
              <div class="row data" v-if="battle.queue" v-for="battle in model.battles">
                <div class="col-4" :title="battle.user1TwitchDisplayName">
                  {{ battle.user1TwitchDisplayName }}
                </div>
                <!--
                <div class="col-2" :title="battle.user1Cards">
                  {{ battle.user1Cards }}
                </div>
                -->
                <div class="col-4" :title="battle.user2TwitchDisplayName">
                  {{ battle.user2TwitchDisplayName }}
                </div>
                <!--
                <div class="col-2" :title="battle.user2Cards">
                  {{ battle.user2Cards }}
                </div>
                -->
                <div class="col-4">
                  <button data-button="start" v-on:click="start(battle.id)" class="small">Start</button>
                  <button data-button="cancel" v-on:click="cancel(battle.id)" class="small">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  `,

  currentBattle: `
    <div data-component="current-battle" class="always-display">
      <section>
        <div class="row">
          <div class="col-12">
            <div class="row columns">
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 1: The Twich display name of user 1.">User 1</label>
              </div>
              <div class="col-4">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 2: The Twich display name of user 2.">User 2</label>
              </div>
              <div class="col-4"></div>
            </div>
            <div v-if="!model.hasResults">
              <h4 class="no-records">No Battle Running</h4>
            </div>
            <div v-if="model.hasResults">
              <div class="row data">
                <div class="col-4" :title="model.battle.user1TwitchDisplayName">
                  {{ model.battle.user1TwitchDisplayName }}
                </div>
                <div class="col-4" :title="model.battle.user2TwitchDisplayName">
                  {{ model.battle.user2TwitchDisplayName }}
                </div>
                <div class="col-4">
                  <button data-button="queue" v-on:click="queue(model.battle.id)" class="small">Queue</button>
                  <button data-button="cancel" v-on:click="cancel(model.battle.id)" class="small">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  `,

  leaderboard: `
    <div data-component="leaderboard">
      <section>
        <div class="row">
          <div class="col-12">
            <div class="card">

              <div class="header">
                <h4>Leaderboard</h4>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row columns">
                    <div class="col-4 top" v-for="user in model.top">
                      <div class="user">
                        <div class="info">
                          <img :src="user.twitchProfileImage" />
                          <span class="trophy">
                            <i class="bi-trophy-fill"></i>
                          </span>
                          <p class="name" :title="user.twitchDisplayName">{{ user.twitchDisplayName }}</p>
                        </div>
                        <div class="wins">
                          <p>{{ user.wins }} Wins</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row columns headers">
                    <div class="col-4 col-md-3">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Username</label>
                    </div>
                    <div class="col-4">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Achievements</label>
                    </div>
                    <div class="col-2 col-md-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Wins</label>
                    </div>
                    <div class="col-2 col-md-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Losses</label>
                    </div>
                    <div class="col-1 d-none d-md-block">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Packs</label>
                    </div>
                    <div class="col-1 d-none d-md-block">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="">Cards</label>
                    </div>
                    <div class="col-1 d-none d-md-block">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title=".">Keys</label>
                    </div>
                  </div>
                  <div class="table">
                    <div class="row data" v-for="user in model.users">
                      <div class="col-4 col-md-3 info">
                        <img :src="user.twitchProfileImage" />
                        <p :title="user.twitchDisplayName">{{ user.twitchDisplayName }}</p>
                      </div>
                      <div class="col-4">
                        <img v-for="a in user.achievements" :data-id="a.id" :src="a.image" class="medal"/>
                      </div>
                      <div class="col-2 col-md-1">
                        <p>{{ user.wins }}</p>
                      </div>
                      <div class="col-2 col-md-1">
                        <p>{{ user.losses }}</p>
                      </div>
                      <div class="col-1 d-none d-md-block">
                        <p>{{ user.packs }}</p>
                      </div>
                      <div class="col-1 d-none d-md-block">
                        <p>{{ user.cards }}</p>
                      </div>
                      <div class="col-1 d-none d-md-block">
                        <p>{{ user.keys }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
        <div data-component="view-medal">
          <div class="view-element"><div></div></div>
        </div>
      </section>
    </div>
  `,

  admin: `
    <div data-component="admin">
      <section>
        <div class="row">
          <div class="col-12">
            <givePack></givePack>
          </div>
          <div class="col-12">
            <giveKey></giveKey>
          </div>
          <div class="col-12">
            <medalAdmin></medalAdmin>
          </div>
          <div class="col-12">
            <addMod></addMod>
          </div>
          <div class="col-12">
            <battleAdmin></battleAdmin>
          </div>
        </div>
      </section>
    </div>
  `,

  givePack: `
    <div data-component="give-pack" class="always-display">
      <div class="card">

        <div class="header margin">
          <h4>Give Pack</h4>
          <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-5">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Display Name: Type the Twitch display name you are looking for.">Display Name</label>
                <input class="form-control search" name="unlock-user" v-on:keyup="searchUsers()" type="text">
              </div>
              <div class="col-5">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select Pack: Select a pack you want to give to a user.">Select Pack</label>
                <select class="form-select" v-model="model.packId">
                  <option v-for="(value, key) in model.packs" v-bind:value="key">
                    {{ value.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  `,

  giveKey: `
    <div data-component="give-key" class="always-display">
      <div class="card">

        <div class="header margin">
          <h4>Give Keys</h4>
          <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-3">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Display Name: Type the Twitch display name you are looking for.">Display Name</label>
                <input class="form-control search" name="key-user" v-on:keyup="searchUsers()" type="text">
              </div>
              <div class="col-3">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select Key: Select a key you want to give to a user.">Select Key</label>
                <select class="form-select" v-model="model.keyId">
                  <option v-for="(value, key) in model.keys" v-bind:value="key">
                    {{ value.name }} - {{ value.description }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  `,

  addMod: `
    <div data-component="add-mod" class="always-display">
      <div class="card">

        <div class="header margin">
          <h4>Add Mod</h4>
          <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-3">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Display Name: Type the Twitch display name you are looking for.">Display Name</label>
                <input class="form-control search" name="mod-user" v-on:keyup="searchUsers()" type="text">
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  `,

  battleAdmin: `
    <div data-component="battle-admin" class="always-display">
      <div class="card">

        <div class="header margin">
          <h4>Battles</h4>
          <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-3">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 1: Search for Twich display name of user 1.">User 1 Display Name</label>
                <input class="form-control search" name="battle-user1" v-on:keyup="searchUsers('battle-user1')"  type="text">
              </div>
              <div class="col-2">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cards 1: Enter the cards for user 1.">Cards 1</label>
                <input class="form-control" v-model="model.battle.user1Cards" type="text">
              </div>
              <div class="col-3">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 2: Search for Twich display name of user 1.">User 2 Display Name</label>
                <input class="form-control search" name="battle-user2" v-on:keyup="searchUsers('battle-user2')" type="text">
              </div>
              <div class="col-2">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cards 2: Enter the cards for user 2.">Cards 2</label>
                <input class="form-control" v-model="model.battle.user2Cards" type="text">
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  `,

  medalAdmin: `
    <div data-component="medal-admin" class="always-display">
      <div class="card">

        <div class="header margin">
          <h4>Achievements</h4>
          <button class="top-margin" data-button="submit" v-on:click="add()">Save</button>
          <button class="top-margin" data-button="submit" v-on:click="get()">Get</button>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-3">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="User 1: Search for Twich display name of the users medal you want to load.">Display Name</label>
                <input class="form-control search" name="medal-user" v-on:keyup="searchUsers()" type="text">
              </div>
              <div class="col-3">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Select Achievement: Select a medal you want to give to a user.">Select Achievement</label>
                <select class="form-select" v-model="model.medalId">
                  <option v-for="(value, key) in model.allMedals" v-bind:value="key">
                    {{ value.name }} - {{ value.description }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="row columns">
              <div class="col-11">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Medal Name: The name of the medal the user has.">Medal</label>
              </div>
              <div class="col-1 edit">
                <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Delete: Click to delete the medal.">Delete</label>
              </div>
            </div>
            <div v-if="!model.hasResults">
              <h4 class="no-records">{{ model.error }}</h4>
            </div>
            <div v-if="model.hasResults">
              <div class="row data" v-for="medal in model.medals" v-if="!medal.deleted">
                <div class="col-11">
                  {{ medal.name }}
                </div>
                <div class="col-1 edit">
                  <i class="bi-trash" v-on:click="remove(medal.id)"></i> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,

  cardAbiltities: `
    <div data-component="card-abilities">
      <section>
        <div class="row">
          <div class="col-12">
            <div class="card">

              <div class="header">
                <h4>Abilities</h4>
                <button class="top-margin" data-button="submit" v-on:click="add()">Add</button>
              </div>

              <div class="row form" v-bind:class="{ visible: model.edit }">
                <div>
                  <i class="bi-x-lg close" v-on:click="reset()"></i> 
                  <div class="col-12">
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables an ability so it can be used.">Active</label>
                      <div class="form-check form-switch">
                        <input v-model="model.ability.active" type="checkbox" class="form-check-input">
                      </div>
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Abilities name.">Name</label>
                      <input class="form-control" v-model="model.ability.name" type="text">
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Detailed description of how the ability works.">Description</label>
                      <input class="form-control" v-model="model.ability.description" type="text">
                    </div>
                    <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="row columns">
                    <div class="col-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables an ability so it can be used.">Active</label>
                    </div>
                    <div class="col-2">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Abilities name.">Name</label>
                    </div>
                    <div class="col-4">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Detailed description of how the ability works.">Description</label>
                    </div>
                    <div class="col-4">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Function ID: Used in the abilities file to name the functions.">Function ID</label>
                    </div>
                    <div class="col-1 edit">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Edit: Click the row to edit the specific record.">Edit</label>
                    </div>
                  </div>
                  <div class="table">
                    <div class="row data" v-for="ability in model.abilities" v-on:click="edit(ability.id)">
                      <div class="col-1">
                        <i v-if="ability.active == true" class="bi-check-lg"></i> 
                        <i v-if="ability.active == false"class="bi-x-lg"></i> 
                      </div>
                      <div class="col-2">
                        {{ ability.name }}
                      </div>
                      <div class="col-4">
                        {{ ability.description }}
                      </div>
                      <div class="col-4">
                        {{ ability.id }}
                      </div>
                      <div class="col-1 edit">
                        <i class="bi-pencil"></i> 
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  `,

  cardTypes: `
  <div data-component="card-types">
    <section>
      <div class="row">
        <div class="col-12">
          <div class="card">

            <div class="header">
              <h4>Types</h4>
              <button class="top-margin" data-button="submit" v-on:click="add()">Add</button>
            </div>

            <div class="row form" v-bind:class="{ visible: model.edit }">
              <div>
                <i class="bi-x-lg close" v-on:click="reset()"></i> 
                <div class="col-12">
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables an card type so it can be used.">Active</label>
                    <div class="form-check form-switch">
                      <input v-model="model.type.active" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Card types name.">Name</label>
                    <input class="form-control" v-model="model.type.name" type="text">
                  </div>
                  <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="row columns">
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables an card type so it can be used.">Active</label>
                  </div>
                  <div class="col-10">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Card types name.">Name</label>
                  </div>
                  <div class="col-1 edit">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Edit: Click the row to edit the specific record.">Edit</label>
                  </div>
                </div>
                <div class="table">
                  <div class="row data" v-for="type in model.types" v-on:click="edit(type.id)">
                    <div class="col-1">
                      <i v-if="type.active == true" class="bi-check-lg"></i> 
                      <i v-if="type.active == false"class="bi-x-lg"></i>
                    </div>
                    <div class="col-10">
                      {{ type.name }}
                    </div>
                    <div class="col-1 edit">
                      <i class="bi-pencil"></i> 
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </div>
  `,

  packs: `
  <div data-component="packs">
    <section>
      <div class="row">
        <div class="col-12">
          <div class="card">

            <div class="header">
              <h4>Packs</h4>
              <button class="top-margin" data-button="submit" v-on:click="add()">Add</button>
            </div>

            <div class="row form" v-bind:class="{ visible: model.edit }">
              <div>
                <i class="bi-x-lg close" v-on:click="reset()"></i> 
                <div class="col-12">
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables the pack so it can be unlocked.">Active</label>
                    <div class="form-check form-switch">
                      <input v-model="model.pack.active" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: The packs name. To allow it to be redeemed via channel points it's name must match the channel points name.">Name</label>
                    <input class="form-control" v-model="model.pack.name" type="text">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Size: How many cards the pack contains.">Size</label>
                    <input class="form-control" v-model="model.pack.size" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Size: How many times this pack can be redeemed.">Limit</label>
                    <input class="form-control" v-model="model.pack.limit" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ultra Chance: What percentage chance that an ultra will be unlocked in this pack.">Ultra</label>
                    <div class="input-group">
                      <input type="number" class="form-control" v-model="model.pack.ultraChance">
                    <span class="input-group-text">%</span>
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Legendary Chance: What percentage chance that a legendary will be unlocked in this pack.">Legendary</label>
                    <div class="input-group">
                      <input type="number" class="form-control" v-model="model.pack.legendaryChance">
                    <span class="input-group-text">%</span>
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ultimate Chance: What percentage chance that an ultimate will be unlocked in this pack.">Ultimate</label>
                    <div class="input-group">
                      <input type="number" class="form-control" v-model="model.pack.ultimateChance">
                    <span class="input-group-text">%</span>
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ultra Guaranteed: Guarantees an ultra will be unlocked in this pack.">Ultra Guaranteed</label>
                    <div class="form-check form-switch">
                      <input v-model="model.pack.ultraGuaranteed" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Legendary Guaranteed: Guarantees a legendary will be unlocked in this pack.">Legendary Guaranteed</label>
                    <div class="form-check form-switch">
                      <input v-model="model.pack.legendaryGuaranteed" type="checkbox" class="form-check-input">
                    </div>
                    <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="row columns">
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables the pack so it can be unlocked.">Active</label>
                  </div>
                  <div class="col-2">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: The packs name. To allow it to be redeemed via channel points it's name must match the channel points name.">Name</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Size: How many cards the pack contains.">Size</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Limit: How many times this pack can be redeemed.">Limit</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ultra Chance: What percentage chance that an ultra will be unlocked in this pack.">Ultra</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Legendary Chance: What percentage chance that a legendary will be unlocked in this pack.">Legendary</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ultimate Chance: What percentage chance that an ultimate will be unlocked in this pack.">Ultimate</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ultra Guaranteed: Guarantees an ultra will be unlocked in this pack.">ULT GTD</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Legendary Guaranteed: Guarantees a legendary will be unlocked in this pack.">LGY GTD</label>
                  </div>
                  <div class="col-1"></div>
                  <div class="col-1 edit">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Edit: Click the row to edit the specific record.">Edit</label>
                  </div>
                </div>
                <div class="table">
                  <div class="row data" v-for="pack in model.packs" v-on:click="edit(pack.id)">
                    <div class="col-1">
                      <i v-if="pack.active == true" class="bi-check-lg"></i> 
                      <i v-if="pack.active == false"class="bi-x-lg"></i> 
                    </div>
                    <div class="col-2" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="pack.name">
                      {{ pack.name }}
                    </div>
                    <div class="col-1">
                      {{ pack.size }}
                    </div>
                    <div class="col-1">
                      {{ pack.limit }}
                    </div>
                    <div class="col-1">
                      {{ pack.ultraChance }}%
                    </div>
                    <div class="col-1">
                      {{ pack.legendaryChance }}%
                    </div>
                    <div class="col-1">
                      {{ pack.ultimateChance }}%
                    </div>
                    <div class="col-1">
                      <i v-if="pack.ultraGuaranteed == true" class="bi-check-lg"></i> 
                      <i v-if="pack.ultraGuaranteed == false"class="bi-x-lg"></i> 
                    </div>
                    <div class="col-1">
                      <i v-if="pack.legendaryGuaranteed == true" class="bi-check-lg"></i> 
                      <i v-if="pack.legendaryGuaranteed == false"class="bi-x-lg"></i> 
                    </div>
                    <div class="col-1"></div>
                    <div class="col-1 edit">
                      <i class="bi-pencil"></i> 
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </div>
  `,

  cards: `
  <div data-component="cards">
    <section>
      <div class="row">
        <div class="col-12">
          <div class="card">

            <div class="header">
              <h4>Cards</h4>
              <button class="top-margin" data-button="submit" v-on:click="add()">Add</button>
            </div>

            <div class="row form" v-bind:class="{ visible: model.edit }">
              <div>
                <i class="bi-x-lg close" v-on:click="reset()"></i> 
                <div class="col-12">
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables a card to be unlocked or used in a battle.">Active</label>
                    <div class="form-check form-switch">
                      <input v-model="model.card.active" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: The card's name.">Name</label>
                    <input class="form-control" v-model="model.card.name" type="text">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Type: The card's type.">Type</label>
                    <select class="form-select" v-model="model.card.type">
                      <option v-for="(value, key) in model.types" v-bind:value="key">
                        {{ value.name }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ability: The card's ability.">Ability</label>
                    <select class="form-select" v-model="model.card.ability">
                      <option value="">No Ability Selected</option>
                      <option v-for="(value, key) in model.abilities" v-bind:value="key">
                      {{ value.name }} - {{ value.description }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="HP: The card's hit points.">HP</label>
                    <input class="form-control" v-model="model.card.hp" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Attack: The card's attack points.">Attack</label>
                    <input class="form-control" v-model="model.card.attack" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Defense: The card's defense points.">Defence</label>
                    <input class="form-control" v-model="model.card.defence" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Accuracy: The card's attach accuracy.">Accuracy</label>
                    <input class="form-control" v-model="model.card.accuracy" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Speed: The card's speed points.">Speed</label>
                    <input class="form-control" v-model="model.card.speed" type="number">
                  </div>
                  <div>
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ultimate: If the card is an ultimate.">Ultimate</label>
                    <div class="form-check form-switch">
                      <input v-model="model.card.ultimate" type="checkbox" class="form-check-input">
                    </div>
                  </div>
                  <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
                  <div v-if="model.card.id"  class="upload">
                    <button data-button="upload">Upload</button>
                    <input type="file" id="file" ref="file" @change="upload"/>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="row columns">
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables a card to be unlocked or used in a battle.">Active</label>
                  </div>
                  <div class="col-2">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: The card's name.">Name</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="HP: The card's hit points.">HP</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Attack: The card's attack points.">Attack</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Defense: The card's defense points.">Defence</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Speed: The card's speed points.">Speed</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Accuracy: The card's attach accuracy.">Accuracy</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Type: The card's type.">Type</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ability: The card's ability.">Ability</label>
                  </div>
                  <div class="col-1">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Ultimate: If the card is an ultimate.">Ultimate</label>
                  </div>
                  <div class="col-1 edit">
                    <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Edit: Click the row to edit the specific record.">Edit</label>
                  </div>
                </div>
                <div class="table">
                  <div class="row data" v-for="card in model.cards" v-on:click="edit(card.id)">
                    <div class="col-1">
                      <i v-if="card.active == true" class="bi-check-lg"></i> 
                      <i v-if="card.active == false" class="bi-x-lg"></i> 
                    </div>
                    <div class="col-2" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="card.name">
                      {{ card.name }}
                    </div>
                    <div class="col-1">
                      {{ card.hp }}
                    </div>
                    <div class="col-1">
                      {{ card.attack }}
                    </div>
                    <div class="col-1">
                      {{ card.defence }}
                    </div>
                    <div class="col-1">
                      {{ card.speed }}
                    </div>
                    <div class="col-1">
                      {{ card.accuracy }}
                    </div>
                    <div class="col-1" title>
                      <span data-bs-toggle="tooltip" data-bs-placement="bottom" v-if="model.types[card.type]" :title="model.types[card.type].name">{{ model.types[card.type].name }}</span>
                    </div>
                    <div class="col-1" title>
                      <span data-bs-toggle="tooltip" data-bs-placement="bottom" v-if="model.abilities[card.ability]" :title="model.abilities[card.ability].description">{{ model.abilities[card.ability].name }}</span>
                    </div>
                    <div class="col-1">
                      <i v-if="card.ultimate == true" class="bi-check-lg"></i> 
                      <i v-if="card.ultimate == false"class="bi-x-lg"></i> 
                    </div>
                    <div class="col-1 edit">
                      <i class="bi-pencil"></i> 
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </section>
  </div>
  `,

  adminKeys: `
    <div data-component="admin-keys">
      <section>
        <div class="row">
          <div class="col-12">
            <div class="card">

              <div class="header">
                <h4>Keys</h4>
                <button class="top-margin" data-button="submit" v-on:click="add()">Add</button>
              </div>

              <div class="row form" v-bind:class="{ visible: model.edit }">
                <div>
                  <i class="bi-x-lg close" v-on:click="reset()"></i> 
                  <div class="col-12">
                    <div> 
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables an key so it can be used.">Active</label>
                      <div class="form-check form-switch">
                        <input v-model="model.key.active" type="checkbox" class="form-check-input">
                      </div>
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Key name.">Name</label>
                      <input class="form-control" v-model="model.key.name" type="text">
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Detailed description of how the key works.">Description</label>
                      <input class="form-control" v-model="model.key.description" type="text">
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Uses: How many times the key can be used. 0 equals infiniate.">Uses</label>
                      <input class="form-control" v-model="model.key.uses" type="number">
                    </div>
                    <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
                    <div v-if="model.key.id"  class="upload">
                      <button data-button="upload">Upload</button>
                      <input type="file" id="file" ref="file" @change="upload"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="row columns">
                    <div class="col-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables an key so it can be used.">Active</label>
                    </div>
                    <div class="col-3">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Key name.">Name</label>
                    </div>
                    <div class="col-4">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Detailed description of how the key works.">Description</label>
                    </div>
                    <div class="col-2">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Uses: How many times the key can be used. 0 equals infiniate.">Uses</label>
                    </div>
                    <div class="col-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Image/Video: Click the icons to view the uploaded image or video.">Image/Video</label>
                    </div>
                    <div class="col-1 edit">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Edit: Click the row to edit the specific record.">Edit</label>
                    </div>
                  </div>
                  <div>
                    <div class="row data" v-for="key in model.keys" v-on:click="edit(key.id)">
                      <div class="col-1">
                        <i v-if="key.active == true" class="bi-check-lg"></i> 
                        <i v-if="key.active == false"class="bi-x-lg"></i> 
                      </div>
                      <div class="col-3">
                        {{ key.name }}
                      </div>
                      <div class="col-4">
                        {{ key.description }}
                      </div>
                      <div class="col-2">
                        {{ key.uses }}
                      </div>
                      <div class="col-1">
                        <a :href="key.image" target="_blank"><i class="bi-file-earmark-image"></i></a>
                        <a :href="key.video" target="_blank"><i class="bi-file-earmark-play"></i></a>
                      </div>
                      <div class="col-1 edit">
                        <i class="bi-pencil"></i> 
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  `,

  adminMedals: `
    <div data-component="admin-medals">
      <section>
        <div class="row">
          <div class="col-12">
            <div class="card">

              <div class="header">
                <h4>Achievements</h4>
                <button class="top-margin" data-button="submit" v-on:click="add()">Add</button>
                </div>

                <div class="row form" v-bind:class="{ visible: model.edit }">
                  <div>
                    <i class="bi-x-lg close" v-on:click="reset()"></i> 
                    <div class="col-12">
                      <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables an medal so it can be used.">Active</label>
                      <div class="form-check form-switch">
                        <input v-model="model.medal.active" type="checkbox" class="form-check-input">
                      </div>
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Medal name.">Name</label>
                      <input class="form-control" v-model="model.medal.name" type="text">
                    </div>
                    <div>
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Detailed description of how the medal works.">Description</label>
                      <input class="form-control" v-model="model.medal.description" type="text">
                    </div>
                    <button class="top-margin" data-button="submit" v-on:click="save()">Save</button>
                    <div v-if="model.medal.id" class="upload">
                      <button data-button="upload">Upload</button>
                      <input type="file" id="file" ref="file" @change="upload"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="row columns">
                    <div class="col-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Active: Enables an medal so it can be used.">Active</label>
                    </div>
                    <div class="col-3">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Name: Medal name.">Name</label>
                    </div>
                    <div class="col-6">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Description: Detailed description of how the medal works.">Description</label>
                    </div>
                    <div class="col-1">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Image/Video: Click the icons to view the uploaded image or video.">Image/Video</label>
                    </div>
                    <div class="col-1 edit">
                      <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Edit: Click the row to edit the specific record.">Edit</label>
                    </div>
                  </div>
                  <div>
                    <div class="row data" v-for="medal in model.medals" v-on:click="edit(medal.id)">
                      <div class="col-1">
                        <i v-if="medal.active == true" class="bi-check-lg"></i> 
                        <i v-if="medal.active == false"class="bi-x-lg"></i> 
                      </div>
                      <div class="col-3">
                        {{ medal.name }}
                      </div>
                      <div class="col-6">
                        {{ medal.description }}
                      </div>
                      <div class="col-1">
                        <a :href="medal.image" target="_blank"><i class="bi-file-earmark-image"></i></a>
                        <a :href="medal.video" target="_blank"><i class="bi-file-earmark-play"></i></a>
                      </div>
                      <div class="col-1 edit">
                        <i class="bi-pencil"></i> 
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  `,

  login: `
    <div data-component="login">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xs-12 col-md-6">
            <div class="card">
              <div class="row justify-content-md-center inputs">
                <div class="col-md-12">
                    <div>
                      <label>Email *</label>
                      <input v-model="model.email" type="email" @keyup.enter="login"/>
                    </div>
                    <div>
                      <label>Password *</label>
                      <input v-model="model.password" type="password" @keyup.enter="login"/>
                    </div>
                </div>
              </div>
              <div class="row submit">
                <div class="col-md-12">
                  <p v-if="model.error" class="error">Incorrect Email/Password Combination</p>
                  <button v-on:click="login" data-button="login">
                      <span v-if="!model.submitting">Log In</span>
                      <div v-if="model.submitting" class="show-spinner is-loading" data-loader="circle-side"></div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,

  stats: `
    <div class="row">
      <div class="col-4 col-md-2" v-for="stat in model.stats">
        <div class="card stats" v-bind:class="stat.type">
          <div class="icon">
            <i :class="stat.icon"></i>
          </div>
          <div class="stat">
            <h3 :title="stat.value">{{ stat.value }}</h3>
            <p :title="stat.type">{{ stat.type }}</p>
          </div>
        </div>
      </div>
    </div>
  `,

  cardLibrary: `
    <div data-component="card-library">
      <div data-page="yours">
      
        <nav v-if="model.page.cards.length">
          <ul class="pagination justify-content-center" v-if="model.page.count > 1">
            <li class="page-item pagination-prev" v-bind:class="{ disabled: model.page.current == 1 }"><a class="page-link" v-on:click="previousPage">Previous</a></li>
            <li class="page-item" v-bind:class="{ active: index == model.page.current }" v-for="index in model.page.count" :key="index"><a class="page-link" v-on:click="setPage(index)">{{index}}</a></li>
            <li class="page-item pagination-next" v-bind:class="{ disabled: model.page.current == model.page.count }"><a class="page-link" v-on:click="nextPage">Next</a></li>
          </ul>
        </nav>

        <div>
          <playing-card v-bind:card="card" v-if="model.page.cards.length && card.active" v-for="card in model.page.cards"></playing-card>
          <h4 class="no-unlocks" v-if="!model.page.cards.length">No Cards Unlocked</h4>
        </div>

        <nav v-if="model.page.cards.length">
          <ul class="pagination justify-content-center" v-if="model.page.count > 1">
            <li class="page-item pagination-prev" v-bind:class="{ disabled: model.page.current == 1 }"><a class="page-link" v-on:click="previousPage">Previous</a></li>
            <li class="page-item" v-bind:class="{ active: index == model.page.current }" v-for="index in model.page.count" :key="index"><a class="page-link" v-on:click="setPage(index)">{{index}}</a></li>
            <li class="page-item pagination-next" v-bind:class="{ disabled: model.page.current == model.page.count }"><a class="page-link" v-on:click="nextPage">Next</a></li>
          </ul>
        </nav>
      </div>

      <div data-page="normal">
        <div>
          <playing-card v-bind:card="card" v-for="card in model.cards.normal"></playing-card>
        </div>
      </div>

      <div data-page="legendary">
        <div>
          <playing-card v-bind:card="card" v-for="card in model.cards.legendary"></playing-card>
        </div>
      </div>

      <div data-page="ultras">
        <div>
          <playing-card v-bind:card="card" v-for="card in model.cards.ultra"></playing-card>
        </div>
      </div>

      <div data-page="ultimates">
        <div>
          <playing-card v-bind:card="card" v-for="card in model.cards.ultimate"></playing-card>
        </div>
      </div>

      <div class="view-card"><div></div></div>

    </div>
  `,

  viewerMedals: `
    <div data-component="viewer-medals">
      <div v-if="model.medals.length" v-for="medal in model.medals" class="medal" :data-id="medal.id">
        <div>
          <img :src="medal.image">
        </div>
        <p :title="medal.name">{{ medal.name }}</p>
        <p :title="medal.description" class="description">{{ medal.description }}</p>
        <p>Unlocked: {{ medal.count }}</p>
      </div>
      <h4 class="no-unlocks" v-if="!model.medals.length">No Achievements Unlocked</h4>

      <div class="view-element"><div></div></div>
    </div>
  `,

  viewerKeys: `
    <div data-component="viewer-keys">
      <div v-if="model.keys.length" v-for="key in model.keys" class="key" :data-id="key.id">
        <div>
          <img :src="key.image">
        </div>
        <p :title="key.name">{{ key.name }}</p>
        <p :title="key.description" class="description">{{ key.description }}</p>
        <p>Uses: {{ key.uses }}</p>
        <p class="bold">Key ID: #{{ key.keyNumber }}</p>
      </div>
      <h4 class="no-unlocks" v-if="!model.keys.length">No Keys Unlocked</h4>

      <div class="view-element"><div></div></div>
    </div>
  `,

  dogTags: `
    <div data-component="dog-tags">
      <div v-if="model.tags.length" class="dogtag-container">
        <div v-for="tag in model.tags" class="dogtag">
          <div class="information">  
            <p class="name" :title="tag.twitchDisplayName">{{ tag.twitchDisplayName }}</p>
          </div>
        </div>
      </div>
      <h4 class="no-unlocks" v-if="!model.tags.length">No Dog Tags</h4>
    </div>
  `,

  battleHelper: `
    <div data-component="battle-helper" v-bind:class="{ 'is-open': model.open }">
      <h4 v-on:click="open()">Battle Helper <button v-bind:class="{ 'is-open': model.open }"><i class="bi-arrow-down-square"></i></button></h4>
      <p>1. Choose the battle command type.</p>
      <p>2. Enter the Twitch display name of the users you want to battle.</p>
      <!--<p>3. Ctrl+click or press and hold on the cards you would like to use in the battle. Select at least <strong>{{model.counts.min}}</strong> cards to battle and a max of <strong>{{model.counts.max}}</strong>.</p>-->
      <p>3. Select a team, Ctrl+click or press and hold on the cards you would like to use in the battle. Select <strong>{{model.counts.min}}</strong> cards to battle with.</p>
      <div class="count">
        <label data-bs-toggle="tooltip" data-bs-placement="bottom">Cards Selected: {{ model.battle.count }}</label>
      </div>
      <div>
        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Command Type: Are you challenging a user or accepting a challenge?">Command Type <i class="bi-info-circle"></i></label>
        <select class="form-select" v-model="model.battle.action" @change="generateCommand">
          <option value="challenge">Challenge</option>
          <option value="accept">Accept</option>
        </select>
      </div>
      <div>
        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Twitch Display Name: Enter the users display name you would like to challenge.">Twitch Display Name <i class="bi-info-circle"></i></label>
        <input class="form-control search" v-model="model.battle.displayName" v-on:keyup="generateCommand()" type="text">
      </div>
      <div>
        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Your Teams: Select one of your team of cards?">Your Teams <i class="bi-info-circle"></i></label>
        <select class="form-select" v-model="model.battle.team" v-on:change="selectTeam">
          <option value="">Select Team</option>
          <option v-for="team in model.battle.teams" :value="team">{{ team.name }}</option>
        </select>
      </div>
      <div class="command" v-bind:class="{ enabled: model.battle.enabled }">
        <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Display Name: Enter the users display name you would like to challenge.">Your Command</label>
        <textarea id="command" readonly class="form-control">{{ model.battle.command }}</textarea>
      </div>
      <button type="button" data-button="copy" v-on:click="copyCommand()" v-bind:class="{ 'is-disabled': !model.battle.enabled }"><i class="bi-clipboard-plus"></i> Copy</button>
      <p class="info">Copy and paste this command into SGTWoofy's stream chat.</p>

      <div class="teams">
        <p>4. Save this team to reuse the group of cards again.</p>
        <div v-bind:class="{ 'is-disabled': model.battle.cards.length != 4 }">
          <label data-bs-toggle="tooltip" data-bs-placement="bottom" title="Team Name: Set a unique name for this team of cards.">Team Name <i class="bi-info-circle"></i></label>
          <input class="form-control" v-model="model.battle.teamName" v-on:keyup="cleanName" type="text">
        </div>
        <button type="button" data-button="save" v-on:click="saveTeam()" v-bind:class="{ 'is-disabled': !model.battle.validName }"><i class="bi-save2"></i> Save Team</button>
        <button type="button" data-button="delete" v-on:click="deleteTeam()" v-bind:class="{ 'is-disabled': !model.battle.validName }"><i class="bi-trash"></i> Delete Team</button>
        <p class="info">You update the name or cards of any team by selecting it and saving your changes.</p>
      </div>
    </div>
  `,

  themeSwitch: `
    <div data-component="theme-switch">
      <div class="row">
        <div class="col-7 col-lg-4">
          <h4>Theme</h4>
        </div>
        <div class="col-2 col-lg-3">
          Light
        </div>
        <div class="col-1 col-lg-2">
          <div class="form-check form-switch">
            <input v-model="model.theme" type="checkbox" class="form-check-input" @change="save()">
          </div>
        </div>
        <div class="col-2 col-lg-3">
          Dark
        </div>
      </div>
    </div>
  `

}


